import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-enterprise';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';

@Component({
    selector: 'app-notification-preference-view',
    templateUrl: './notification-preference-view.component.html',
    styleUrls: ['./notification-preference-view.component.css'],
    standalone: false
})
export class NotificationPreferenceViewComponent implements OnInit {

  messages: any;
  columnDefs: (ColDef | ColGroupDef)[];
  notificationPreferenceOptions: GridOptions = this.initializeGridOptions();
  rowData: any;
  public overlayNoRowsTemplate;
  private gridApi;

  constructor(private tmssLoader: LoadingService,
              private bsModalRef: BsModalRef,
              public options: ModalOptions
  ) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No rows to display, please adjust your filters</span>';
   }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        flex: 1,
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: this.messages,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption('headerHeight', 30);
  }

  ngOnInit() {
    this.messages = this.options.initialState;
    this.rowData = this.messages.notificationPreferences;
    this.updateColumnDefs();
    this.tmssLoader.hide();
  }


  updateColumnDefs() {
    this.columnDefs = this.getNotificationPreferenceColumnDefs();
  }

  getNotificationPreferenceColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          flex: 1,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          headerName: 'Email',
          field: 'email',
          filter: 'agTextColumnFilter',
          sortable: true

        },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Notification Type',
        field: 'notifType',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Business Type',
        field: 'busType',
        filter: 'agTextColumnFilter',
        sortable: true
      }
    ];
  }

  loadMessageHistory(existingMessages) {
    /* for(let i = 0; i<existingMessages.length(); i++) {
      this.messageHistoryArray[i] = existingMessages[i].message;
    } */
  }

  /**
   * @description cancel message entered
   */
  cancelMessage() {
    // this.bsModalRef.hide();
  }

  closeModal() {
    this.bsModalRef.hide();

  }


}
